import {
    AI_BRIEF_N_OUTLINE_CREDITS_REQUIRED,
    OPTIMIZER_AI_CREDITS_REQUIRED,
} from '../../components/common/tiptapEditor/constants/aiEditorConstants';
import {
    AI_OPTIMIZER_BRIEF_N_OUTLINE,
    AI_OPTIMIZER_WHOLE,
    aiInstanceTypes,
    aiStatus,
} from '../../constants/aiOptimizerConstants';
import {
    openBasicErrorNotification,
    openBasicSuccessNotification,
} from './openBasicErrorNotification';

export const getAiOptimizerCost = (aiOptimizerOptions = null) => {
    switch (aiOptimizerOptions) {
        case AI_OPTIMIZER_WHOLE:
            return OPTIMIZER_AI_CREDITS_REQUIRED;
        case AI_OPTIMIZER_BRIEF_N_OUTLINE:
            return AI_BRIEF_N_OUTLINE_CREDITS_REQUIRED;
        default:
            return 0;
    }
};

export const areNotEnoughAiCredits = (remainingOpenAIBriefs = 0, aiOptimizerOptions = null) => {
    return remainingOpenAIBriefs < getAiOptimizerCost(aiOptimizerOptions);
};

export const isCurrentAiProcessFinished = (generationStatus = '', checkIfStarted = true) => {
    return (
        (checkIfStarted ? (generationStatus?.length || 0) > 0 : true) &&
        aiStatus.FINAL_STATUSES.includes(generationStatus)
    );
};

export const isCurrentAiProcessInProgress = (generationStatus = '') => {
    const isStarted = (generationStatus?.length || 0) > 0;
    return isStarted && !aiStatus.FINAL_STATUSES.includes(generationStatus);
};

export const showAiResultMessage = (
    generationStatus = '',
    aiInstanceType = aiInstanceTypes.CONTENT
) => {
    if (generationStatus?.length === 0) return;

    const messageText = `AI ${aiInstanceType} generation ${generationStatus}`;
    const successMessageText = `Your AI ${aiInstanceType} is ready for review!`;

    if (generationStatus === aiStatus.COMPLETED) {
        openBasicSuccessNotification(null, successMessageText, 3);
    } else if (aiStatus.FINAL_FAILED_STATUSES.includes(generationStatus)) {
        openBasicErrorNotification(messageText + ', AI credits returned');
    }
};
